import { action } from 'satcheljs';

export const onVisualThemingStarted = action('ON_VISUAL_THEMING_STARTED', (themeId: string) => ({
    themeId,
}));

export const onVisualThemingEnded = action('ON_VISUAL_THEMING_ENDED', (themeId?: string) => ({
    themeId,
}));
